import { render, staticRenderFns } from "./invoice_history.vue?vue&type=template&id=3845e616&scoped=true&"
import script from "./invoice_history.vue?vue&type=script&lang=js&"
export * from "./invoice_history.vue?vue&type=script&lang=js&"
import style0 from "./invoice_history.vue?vue&type=style&index=0&id=3845e616&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3845e616",
  null
  
)

export default component.exports